import { render, staticRenderFns } from "./ListAgreements.vue?vue&type=template&id=fb795cc8&scoped=true&"
import script from "./ListAgreements.vue?vue&type=script&lang=js&"
export * from "./ListAgreements.vue?vue&type=script&lang=js&"
import style0 from "./ListAgreements.vue?vue&type=style&index=0&id=fb795cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb795cc8",
  null
  
)

export default component.exports